export default __webpack_public_path__ + "static/media/logo.f4af5c16.png";